import { isLegacySignupCode, isLegacySignupCreatePatientResponseDto } from '../../esl';
import { ConversionException } from '../../models';
export class LegacySignupResponseDtoToLegacySignupResponseConverter {
    static create = () => {
        return new LegacySignupResponseDtoToLegacySignupResponseConverter();
    };
    toModel = (source) => {
        if (isLegacySignupCode(source)) {
            return {
                code: source,
            };
        }
        else if (isLegacySignupCreatePatientResponseDto(source)) {
            return {
                code: source.key,
                emailMask: source.emailMask,
            };
        }
        else {
            throw new ConversionException('Unable to convert Legacy Signup Response', source);
        }
    };
}
